export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      features: "Features",
      modules: "Modules",
      benefits: "Benefits",
      faq: "FAQ",
      contact: "Contact us",
      bookDemo: "Book Demo",
    },

    // Hero Section
    hero: {
      slide1Title:
        "Purna Academic – The Best School ERP & Academic Management Software",
      slide1Subtitle:
        "A complete cloud-based school ERP to manage admissions, attendance, fees, exams, payroll, and academics in one platform.",
      slide2Title: "Smart School Management Software for Institutions",
      slide2Subtitle:
        "Designed for schools, colleges, and educational trusts with government-compliant reporting including UDISE, Saral, and Shala Siddhi.",
      slide3Title: "Secure, Scalable & Easy-to-Use School ERP Software",
      slide3Subtitle:
        "Trusted by institutions across India for complete digital academic transformation from pre-primary to post-graduate.",
      getDemo: "Get Demo",
      contactSales: "Contact Sales",
      institutions: "Institutions",
      studentsManaged: "Students Managed",
      satisfactionRate: "Satisfaction Rate",
    },

    // Features Section
    features: {
      title: "Features",
      subtitle: "Comprehensive Features for Modern Educational Institutions",
      admissionManagement: "Admission Management",
      admissionDesc:
        "Streamline the admission process with online forms, document management, and automated notifications.",
      attendanceTracking: "Attendance Tracking",
      attendanceDesc:
        "Real-time attendance marking with biometric integration and automated parent notifications.",
      feeManagement: "Fee Management",
      feeDesc:
        "Automated fee collection, invoicing, and payment reconciliation with multiple payment gateways.",
      examManagement: "Exam Management",
      examDesc:
        "Create, manage, and analyze exams with question banks, result generation, and performance analytics.",
      reportGeneration: "Report Generation",
      reportDesc:
        "Generate comprehensive reports for students, parents, and administrators with compliance features.",
      parentPortal: "Parent Portal",
      parentDesc:
        "Keep parents engaged with real-time updates on academics, attendance, and exam performance.",
    },

    // Modules Section
    modules: {
      title: "Modules",
      subtitle: "Everything You Need to Run Your Institution",
      studentManagement: "Student Management",
      view: "View Modules",
      staffManagement: "Staff Management",
      classManagement: "Class Management",
      timeTable: "Time Table",
      examination: "Examination",
      library: "Library",
      inventory: "Inventory",
      payroll: "Payroll",
      accounting: "Accounting",
      transport: "Transport",
      hostel: "Hostel",
      communication: "Communication",
    },

    // Why Choose Section
    whyChoose: {
      title: "Why Choose Purna Academic",
      subtitle: "Benefits of Our Complete ERP Solution",
      cloudBased: "Cloud-Based Solution",
      cloudDesc:
        "Access your data anytime, anywhere with our secure cloud infrastructure.",
      userFriendly: "User-Friendly Interface",
      userDesc:
        "Intuitive design that requires minimal training for staff and parents.",
      government: "Government Compliant",
      governmentDesc:
        "Fully compliant with UDISE, Saral, and Shala Siddhi requirements.",
      secure: "Secure & Reliable",
      secureDesc: "Enterprise-grade security with 99.9% uptime guarantee.",
      mobile: "Mobile App",
      mobileDesc:
        "iOS and Android apps for students and parents to stay connected.",
      support: "24/7 Support",
      supportDesc:
        "Dedicated support team available round the clock for assistance.",
    },

    // Benefits Section
    benefits: {
      title: "Key Benefits",
      subtitle: "Transform Your Institution",
      efficiency: "Increased Efficiency",
      efficiencyDesc:
        "Automate routine tasks and reduce administrative burden by 80%.",
      transparency: "Better Transparency",
      transparencyDesc:
        "Real-time data access for all stakeholders ensures transparency.",
      parentEngagement: "Improved Parent Engagement",
      parentDesc:
        "Keep parents informed with instant notifications and portals.",
      costSavings: "Cost Savings",
      costDesc: "Reduce paper usage and operational costs significantly.",
      datadriven: "Data-Driven Decisions",
      datadrivenDesc:
        "Make informed decisions with comprehensive analytics and reports.",
      growth: "Institutional Growth",
      growthDesc:
        "Scale your institution without scaling administrative overhead.",
    },

    // Testimonials Section
    testimonials: {
      title: "What Our Clients Say",
      testimonial1:
        "Purna Academic has transformed the way we manage our institution. The system is intuitive and has reduced our workload significantly.",
      testimonial2:
        "The parent portal feature is excellent. Parents are now more engaged and informed about their child's progress.",
      testimonial3:
        "Best investment we made for our school. The ROI has been exceptional with improved efficiency and reduced costs.",
    },

    // FAQ Section
    faq: {
      title: "Frequently Asked Questions",
      q1: "What is Purna Academic?",
      a1: "Purna Academic is a comprehensive cloud-based school ERP software designed to manage all aspects of educational institutions.",
      q2: "Is it secure?",
      a2: "Yes, we use enterprise-grade security with SSL encryption, regular backups, and compliance with international standards.",
      q3: "Can I integrate with existing systems?",
      a3: "Yes, our system supports integration with most popular educational software through APIs.",
      q4: "What kind of support do you provide?",
      a4: "We provide 24/7 technical support, training, and regular updates to ensure smooth operation.",
      q5: "Is there a mobile app?",
      a5: "Yes, we have dedicated mobile apps for iOS and Android for students, teachers, and parents.",
      q6: "How much does it cost?",
      a6: "Our pricing is flexible and depends on your institution size. Contact our sales team for a custom quote.",
    },

    // Contact Section
    contact: {
      title: "Schedule Your Free Demo",
      subtitle:
        "Experience the power of Purna Academic with a personalized demo tailored to your institution's needs.",
      bookDemo: "Book a Demo",
      fillDetails:
        "Fill in your details and our team will contact you shortly.",
      yourName: "Your Name",
      institutionName: "Institution Name",
      phoneNumber: "Phone Number",
      emailAddress: "Email Address",
      institutionAddress: "Institution Address",
      scheduleDemo: "Schedule Free Demo",
      submitting: "Submitting...",
      thankYou: "Thank you! We'll contact you shortly to schedule your demo.",
      officeAddress: "Office Address",
      officeDesc:
        "TechnoAarv Solutions. Shanti Sadan Apartment, Near Limaye Eye Care Hospital, Vishrambag, Sangli, India.",
      puneAddr: "Ganesh Park, Lohegaon Wagholi Road, Lohegaon, Pune",  
      phoneNum: "Phone Number",
      phoneNumVal: "+91 9130093700",
      emailAddr: "Email Address",
      emailVal: "technoaarv@gmail.com",
      businessHours: "Business Hours",
      businessDesc: "Mon - Sat: 9:30 AM - 6:30 PM",
    },

    // Footer
    footer: {
      company: "Company",
      about: "About Us",
      careers: "Careers",
      blog: "Blog",
      press: "Press",
      product: "Product",
      features: "Features",
      pricing: "Pricing",
      security: "Security",
      roadmap: "Roadmap",
      support: "Support",
      contactUs: "Contact Us",
      documentation: "Documentation",
      helpCenter: "Help Center",
      status: "Status",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      copyright: "© 2024 Purna Academic. All rights reserved.",
    },

    // Modules Section Extended
    modulesSection: {
      title: "Comprehensive Modules",
      subtitle:
        "Explore our integrated modules designed to handle every aspect of school management software requirements.",
      admissionTitle: "Admission Management",
      admissionFeatures: [
        "Prospectus sales and enquiry management",
        "Online and offline admission processing",
        "Document verification and finalization",
        "Merit list generation",
        "Admission cancellation handling",
        "General register management",
      ],
      academicsTitle: "Academic Management",
      academicsFeatures: [
        "Class and division allocation",
        "Subject classification by class",
        "Timetable creation and management",
        "Lesson plan tracking",
        "Syllabus completion reports",
        "Teacher workload management",
      ],
      examsTitle: "Examination Module",
      examsFeatures: [
        "Exam schedule creation",
        "Classroom allocation for exams",
        "Marks entry and grade calculation",
        "Progress reports generation",
        "Mark lists and provisional certificates",
        "Performance analytics by student/class",
      ],
      financeTitle: "Finance & Accounts",
      financeFeatures: [
        "Fee structure by session/course/semester",
        "Online and counter fee collection",
        "Voucher entry and ledger management",
        "Bank reconciliation",
        "Balance sheet and trial balance",
        "Budget planning and reporting",
      ],
      hrTitle: "HR & Payroll",
      hrFeatures: [
        "Complete employee information",
        "Biometric and RFID attendance",
        "Leave management system",
        "Salary statement preparation",
        "Loan and PF management",
        "Income tax management",
      ],
      libraryTitle: "Library Management",
      libraryFeatures: [
        "Book and newspaper registers with barcodes",
        "Check-in/check-out tracking",
        "Student library card generation",
        "Fine management",
        "Book barcode creation",
        "Inventory reports",
      ],
      inventoryTitle: "Store & Inventory",
      inventoryFeatures: [
        "Item and supplier master",
        "Purchase request and approval workflow",
        "Purchase order management",
        "Sales and purchase registers",
        "Maintenance expense tracking",
        "Stock balance reports",
      ],
      communicationTitle: "Communication",
      communicationFeatures: [
        "SMS and email notifications",
        "Attendance alerts to parents",
        "Fee reminder messages",
        "Exam schedule notifications",
        "Birthday wishes automation",
        "Event and holiday announcements",
      ],
      mobileTitle: "Mobile App",
      mobileFeatures: [
        "Parent and teacher login",
        "View student academic details",
        "Attendance visibility",
        "Exam timetable access",
        "Fee details and progress reports",
        "Direct communication with teachers",
      ],
      budgetTitle: "Budget Management",
      budgetFeatures: [
        "Keeping income and expense accounts",
        "Preparing school or management budget reports",
        "Preparing institution-wise budget reports",
        "Consolidated budget reports",
        "Calculating budget differences between years",
      ],
      donationTitle: "Donation Receipt",
      donationFeatures: [
        "Creating donation master",
        "Centralizing donation collection",
        "Preparing school-wise donation reports",
        "Consolidated donation receipt reports",
        "Preparing 80G reports",
      ],
      certificatesTitle: "Certificates",
      certificatesFeatures: [
        "Bonafide certificates with or without student photo",
        "Leaving certificate in Marathi/English (LC/TC)",
        "Character Certificate",
        "Attendance Certificate",
      ],
      idcardTitle: "ID Card Module",
      idcardFeatures: [
        "Easy printing of updated ID cards",
        "Generate ID cards by uploading student photos",
      ],
      mealTitle: "Mid-Day-Meal",
      mealFeatures: [
        "Create and manage masters for grains and other items",
        "Grain and items supply register",
        "Distribution of grains by class and age",
        "Register of cooked items with attendance count",
        "Monthly, quarterly and annual government reports",
      ],
      scholarshipTitle: "Scholarship Management",
      scholarshipFeatures: [
        "Scholarship category and payment department master",
        "Scholarship initial balance and distribution",
        "Scholarship distribution and year-wise summary reports",
        "Additional scholarship management",
        "Additional scholarship refunds",
        "Linking scholarship to accounts module",
      ],
    },

    // Benefits Section Extended
    benefitsSection: {
      benefitForManagement: "For School Management",
      benefitForTeachers: "For Teachers",
      benefitForParents: "For Parents",
      managementBenefits: [
        "Real-time dashboards with instant insights",
        "Multi-campus control and monitoring",
        "Financial planning and budget reports",
        "Consolidated government reports",
        "Employee management system",
        "Effective parent-teacher communication",
      ],
      teacherBenefits: [
        "Easy attendance and marks entry",
        "Lesson planning and syllabus tracking",
        "Time-saving automation features",
        "Access to student information",
        "Internal messaging system",
        "Timetable and schedule access",
      ],
      parentBenefits: [
        "Real-time child progress updates",
        "Attendance and exam notifications",
        "Fee tracking and online payment",
        "SMS and app notifications",
        "Direct teacher communication",
        "Easy access via mobile app",
      ],
      benefitsTitle: "Benefits for Everyone",
      benefitsSubtitle:
        "Our school management software delivers value to all stakeholders - management, teachers, and parents alike.",
    },

    // FAQ Section Extended
    faqSection: {
      title: "Frequently Asked Questions",
      subtitle:
        "Get answers to common questions about our school ERP and academic management software.",
      q1: "What is School ERP Software?",
      a1: "School ERP (Enterprise Resource Planning) Software is a comprehensive digital solution that integrates all school operations including admissions, fee management, attendance, examinations, academics, payroll, and communication into a single unified platform. Purna Academic is a complete school ERP designed specifically for Indian educational institutions.",
      q2: "How does Academic Management Software help schools?",
      a2: "Academic Management Software like Purna Academic helps schools by automating routine administrative tasks, reducing paperwork, improving communication between stakeholders, generating instant reports, ensuring data accuracy, and enabling real-time monitoring of all school activities. This leads to significant time savings and better decision-making.",
      q3: "Is Purna Academic suitable for CBSE, State Board, and colleges?",
      a3: "Yes, Purna Academic is designed to work with all types of educational institutions - from pre-primary to post-graduate level. It supports CBSE, ICSE, State Boards, and various college/university systems. The software is flexible enough to adapt to different academic structures and examination patterns.",
      q4: "Does the system support government reports like UDISE, Saral, and Shala Siddhi?",
      a4: "Absolutely! Purna Academic comes with built-in support for all major government reporting requirements including UDISE Plus, Saral, Shala Siddhi, and reports required by Central and Zilla Parishad. These reports can be generated with just a few clicks, saving hours of manual work.",
      q5: "Is Purna Academic a cloud-based school ERP?",
      a5: "Yes, Purna Academic is a cloud-based school ERP software that allows you to access your school data from anywhere, anytime. All data is securely stored and backed up on cloud servers, ensuring data safety and accessibility across devices.",
      q6: "What languages does Purna Academic support?",
      a6: "Purna Academic supports both Marathi and English languages, making it accessible for schools across Maharashtra and other regions. The bilingual support extends to all modules including certificates, reports, and user interfaces.",
      q7: "Is there any limit on the number of students or teachers?",
      a7: "No, there is no limit on the number of students or teachers in Purna Academic. Whether you're a small school with 100 students or a large trust managing multiple institutions with thousands of students, our school management software scales to meet your needs.",
      q8: "What training and support is provided?",
      a8: "We provide comprehensive training to all school staff during implementation. Our support team is available to help with any queries or issues. Regular updates and feature enhancements are included, ensuring your school always has access to the latest capabilities.",
    },

    // Why Choose Section Extended
    whyChooseSection: {
      subtitle: "The Complete Academic Management Software for Indian Schools",
      description:
        "Purna Academic is trusted by 500+ institutions across India for its comprehensive approach to school management. From pre-primary to post-graduate, our school ERP software adapts to your institution's unique needs.",
      getStarted: "Get Started Today",
      benefits: [
        "Complete School ERP Solution covering all administrative needs",
        "Cloud-based & Secure with data backup and protection",
        "Marathi & English Language Support for regional accessibility",
        "Government-Ready Reports (UDISE, Saral, Shala Siddhi)",
        "No limit on students or teachers - scales with your institution",
        "Comprehensive Training & Support included with every plan",
        "Multi-campus management for educational trusts",
        "Integrated accounts linking fees, payroll, and inventory",
      ],
      preToPostGrad: "Pre-Primary to PG",
      cloudBased: "Cloud Based",
      multiLanguage: "Multi-Language",
      govCompliant: "Govt Compliant",
    },

    // Testimonials Section Extended
    testimonialsSection: {
      title: "What Our Users Say",
      subtitle:
        "Trusted by educators across India for comprehensive academic management.",
      testimonial1:
        "Purna Academic has transformed how we manage our school. The automated fee collection and attendance SMS to parents have reduced our administrative burden by 70%.",
      testimonial1Name: "Dr. Suresh Patil",
      testimonial1Role: "Principal, Modern Public School",
      testimonial2:
        "The government-ready reports feature is a lifesaver. UDISE, Saral, and Shala Siddhi reports are generated with just a click. Highly recommended for all schools!",
      testimonial2Name: "Mrs. Anjali Deshpande",
      testimonial2Role: "Administrator, Vidya Mandir Trust",
      testimonial3:
        "As a parent, I love the mobile app. I can track my child's attendance, exam results, and fee status anytime. The communication with teachers has become so easy.",
      testimonial3Name: "Mr. Rajesh Kumar",
      testimonial3Role: "Parent",
      testimonial4:
        "The Marathi language support makes it accessible for all our staff. Training was excellent, and the support team is always responsive. Best school ERP we've used.",
      testimonial4Name: "Prof. Mahadev Kulkarni",
      testimonial4Role: "Vice Principal, Saraswati Vidyalaya",
    },

    // Customers Section
    customersSection: {
      title: "Our Trusted Customers",
      subtitle:
        "Trusted by schools, colleges, and educational institutions across India for comprehensive academic management solutions.",
      previousCustomers: "Previous customers",
      nextCustomers: "Next customers",
    },

    // Footer Section Extended
    footerSection: {
      brandDesc:
        "Purna Academic is a complete School ERP and Academic Management Software for Indian educational institutions. From pre-primary to post-graduate, we help schools automate admissions, attendance, fees, exams, payroll, and communication with government-compliant reporting.",
      quickLinks: "Quick Links",
      ourModules: "Our Modules",
      contactUs: "Contact Us",
      home: "Home",
      features: "Features",
      modules: "Modules",
      benefits: "Benefits",
      faq: "FAQ",
      contact: "Contact",
      admissionManagement: "Admission Management",
      feeManagement: "Fee Management",
      attendanceSystem: "Attendance System",
      examinationModule: "Examination Module",
      hrPayroll: "HR & Payroll",
      mobileApp: "Mobile App",
      address1:
        "TechnoAarv Solutions. Shanti Sadan Apartment, Near Limaye Eye Care Hospital, Vishrambag, Sangli, India.",
      address2: "Ganesh Park, Lohegaon Wagholi Road, Lohegaon, Pune",
      phone: "+91 9130093700",
      email: "technoaarv@gmail.com",
      copyright:
        "© 2024 Purna Academic. All rights reserved. | developed and managed by TechnoAarv Solutions",
    },

    // Messages
    messages: {
      allFieldsRequired:
        "All fields are required. Please fill in all the details.",
      submissionError: "Failed to submit form. Please try again later.",
      unexpectedError: "An unexpected response was received. Please try again.",
      phoneError: "Phone number must be exactly 10 digits",
      emailError: "Please enter a valid email address",
    },
  },

  mr: {
    // Navigation
    nav: {
      home: "होम",
      features: "वैशिष्ट्य",
      modules: "मॉड्यूल",
      benefits: "लाभ",
      faq: "सामान्य प्रश्न",
      contact: "आमच्याशी संपर्क",
      bookDemo: "डेमो बुक करा",
    },

    // Hero Section
    hero: {
      slide1Title:
        "पूर्ण अकॅडमिक – सर्वश्रेष्ठ स्कूल ERP आणि अकॅडमिक व्यवस्थापन सॉफ्टवेअर",
      slide1Subtitle:
        "एक संपूर्ण क्लाउड-आधारित स्कूल ERP जो प्रवेश, उपस्थिती, शुल्क, परीक्षा, वेतन आणि शैक्षणिक सर्व गोष्टी एक प्लॅटफॉर्मवर व्यवस्थापित करते.",
      slide2Title: "शैक्षणिक संस्थांसाठी स्मार्ट स्कूल मॅनेजमेंट सॉफ्टवेअर",
      slide2Subtitle:
        "शाळा, कॉलेज आणि शैक्षणिक ट्रस्टसाठी खास तयार केलेले. यामध्ये UDISE, सरल आणि शाळा सिद्धी यांसारखे सरकारी रिपोर्ट्स (Reports) सहज मिळतात.",
      slide3Title: "सुरक्षित, स्केलेबल आणि वापरण्यास सोपे स्कूल ERP सॉफ्टवेअर",
      slide3Subtitle:
        "भारतभर संस्थांद्वारे विश्वास्त प्राथमिक ते पदव्युत्तर अकॅडमिक परिवर्तनासाठी.",
      getDemo: "डेमो मिळवा",
      contactSales: "विक्रय संपर्क",
      institutions: "संस्था",
      studentsManaged: "विद्यार्थी व्यवस्थापित",
      satisfactionRate: "समाधान दर",
    },

   features: {
  title: "प्रमुख वैशिष्ट्ये",
  subtitle: "आजच्या आधुनिक शाळा आणि शैक्षणिक संस्थांसाठी सर्व काही एकाच ठिकाणी",
  admissionManagement: "ॲडमिशन मॅनेजमेंट",
  admissionDesc: "ऑनलाइन फॉर्म, कागदपत्रांचे व्यवस्थापन आणि ऑटोमॅटिक सूचनांद्वारे प्रवेश प्रक्रिया करा अधिक सोपी.",
  attendanceTracking: "हजेरी ट्रॅकिंग",
  attendanceDesc: "बायोमेट्रिक सिस्टीमद्वारे रिअल-टाइम हजेरी आणि पालकांना मेसेजद्वारे त्वरित माहिती देण्याची सोय.",
  feeManagement: "फी व्यवस्थापन (Fee Management)",
  feeDesc: "ऑनलाइन फी भरणे, पावत्या तयार करणे आणि पेमेंटचा हिशोब ठेवणे - सर्व काही आता ऑटोमॅटिक.",
  examManagement: "परीक्षा व्यवस्थापन",
  examDesc: "प्रश्नपत्रिका तयार करण्यापासून ते निकाल लावण्यापर्यंत आणि प्रगतीचे विश्लेषण करण्यापर्यंत सर्व काही झटपट करा.",
  reportGeneration: "रिपोर्ट्स तयार करणे",
  reportDesc: "विद्यार्थी, पालक आणि प्रशासनासाठी लागणारे सर्व महत्त्वाचे रिपोर्ट्स एका क्लिकवर मिळवा.",
  parentPortal: "पालक पोर्टल (Parent Portal)",
  parentDesc: "मुलांचा अभ्यास, हजेरी आणि परीक्षेतील प्रगती यावर पालकांना थेट मोबाईलवर लक्ष ठेवता येईल.",
},

    // Modules Section
    modules: {
      title: "मॉड्यूल",
      subtitle: "आपल्या संस्था चलविण्यासाठी आवश्यक असलेली सर्व गोष्टी",
      studentManagement: "विद्यार्थी व्यवस्थापन",
      view: "मॉड्यूल पहा",
      staffManagement: "कर्मचारी व्यवस्थापन",
      classManagement: "वर्ग व्यवस्थापन",
      timeTable: "वेळापत्रक",
      examination: "परीक्षा",
      library: "ग्रंथालय",
      inventory: "इन्व्हेंटरी",
      payroll: "पेरोल",
      accounting: "लेखांकन",
      transport: "वाहतूक",
      hostel: "छात्रावास",
      communication: "संवाद",
    },

    // Why Choose Section
    whyChoose: {
      title: "पूर्ण अकॅडमिक का निवडा",
      subtitle: "आमच्या संपूर्ण ERP समाधानाचे लाभ",
      cloudBased: "क्लाउड-आधारित समाधान",
      cloudDesc:
        "आमच्या सुरक्षित क्लाउड अवसंरचनासह कधीही, कुठेही आपलेे डेटा अ‍ॅक्सेस करा.",
      userFriendly: "वापरकर्ता-अनुकूल इंटरफेस",
      userDesc:
        "कर्मचारी आणि पालकांसाठी किमान प्रशिक्षणासह अंतर्ज्ञानी डिजाइन.",
      government: "सरकार अनुगत",
      governmentDesc:
        "UDISE, Saral आणि Shala Siddhi आवश्यकताओंसह पूर्णतया अनुगत.",
      secure: "सुरक्षित आणि विश्वसनीय",
      secureDesc: "99.9% अपटाइम गारंटीसह एंटरप्राइज-ग्रेड सुरक्षा.",
      mobile: "मोबाइल अ‍ॅप",
      mobileDesc:
        "विद्यार्थी आणि पालकांना जोडून ठेवण्यासाठी आयओएस आणि अँड्रॉयड अ‍ॅप.",
      support: "24/7 समर्थन",
      supportDesc: "सहायतासाठी सर्वदा उपलब्ध समर्पित समर्थन टीम.",
    },

    // Benefits Section
    benefits: {
      title: "मुख्य लाभ",
      subtitle: "आपल्या संस्था बदलणे",
      efficiency: "वाढलेली कार्यक्षमता",
      efficiencyDesc:
        "दिनचर्या कार्य स्वयंचलित करा आणि प्रशासकीय भार 80% कमी करा.",
      transparency: "चांगली पारदर्शकता",
      transparencyDesc:
        "सर्व हिताधारकांसाठी वास्तविक वेळ डेटा अ‍ॅक्सेस पारदर्शकता सुनिश्चित करते.",
      parentEngagement: "सुधारलेले पालक संलग्नता",
      parentDesc: "त्वरित सूचना आणि पोर्टलसह पालकांना माहितीदार ठेवा.",
      costSavings: "खर्च बचत",
      costDesc: "कागद वापर आणि परिचालन खर्च लक्षणीयरीत्या कमी करा.",
      datadriven: "डेटा-संचालित निर्णय",
      datadrivenDesc: "व्यापक विश्लेषण आणि अहवाल सह माहितीपूर्ण निर्णय घ्या.",
      growth: "संस्थांचे वृद्धी",
      growthDesc: "प्रशासकीय ओव्हरहेड वाढविल्याशिवाय आपला संस्था मापन करा.",
    },

    // Testimonials Section
    testimonials: {
      title: "आमचे ग्राहक काय म्हणतात",
      testimonial1:
        "पूर्ण अकॅडमिकने आमच्या संस्था व्यवस्थापनाचे पद्धत बदलले. प्रणाली अंतर्ज्ञानी आहे आणि आमचे कार्यभार लक्षणीयरीत्या कमी केले आहे.",
      testimonial2:
        "पालक पोर्टल वैशिष्ट्य उत्कृष्ट आहे. पालक आता अधिक गुंतवलेले आणि आपल्या मुलाच्या प्रगतीबद्दल माहितीदार आहेत.",
      testimonial3:
        "आमच्या शाळेसाठी केलेला सर्वोत्तम गुंतवणूक. ROI असाधारण आहे सुधारलेली कार्यक्षमता आणि कमी खर्चासह.",
    },

    // FAQ Section
    faq: {
      title: "वारंवार विचारलेले प्रश्न",
      q1: "पूर्ण अकॅडमिक म्हणजे काय?",
      a1: "पूर्ण अकॅडमिक एक व्यापक क्लाउड-आधारित स्कूल ERP सॉफ्टवेअर आहे जो शैक्षणिक संस्थांचे सर्व पहलू व्यवस्थापित करतो.",
      q2: "हे सुरक्षित आहे का?",
      a2: "होय, आम्ही एसएसएल एन्क्रिप्शन, नियमित बॅकअप आणि आंतरराष्ट्रीय मानकांच्या अनुपालन सह एंटरप्राइज-ग्रेड सुरक्षा वापरतो.",
      q3: "मी विद्यमान प्रणालीसह एकीकृत करू शकतो का?",
      a3: "होय, आमची प्रणाली एपीआय द्वारे सर्वात लोकप्रिय शैक्षणिक सॉफ्टवेअरसह एकीकरणाला समर्थन करते.",
      q4: "आप कोणत्या प्रकारचे समर्थन प्रदान करतो?",
      a4: "आम्ही 24/7 तांत्रिक समर्थन, प्रशिक्षण आणि नियमित अपडेट प्रदान करतो गुळगुळीत ऑपरेशन सुनिश्चित करण्यासाठी.",
      q5: "एक मोबाइल अ‍ॅप आहे का?",
      a5: "होय, आमच्याकडे विद्यार्थी, शिक्षक आणि पालकांसाठी आयओएस आणि अँड्रॉयड साठी समर्पित मोबाइल अ‍ॅप आहेत.",
      q6: "यात किती खर्च होतो?",
      a6: "आमचे मूल्य निर्धारण लचकदार आहे आणि आपल्या संस्थांचे आकार यावर अवलंबून आहे. कस्टम कोटसाठी आमच्या विक्रय टीमशी संपर्क करा.",
    },

    // Contact Section
    contact: {
      title: "मोफत डेमो पाहण्यासाठी नोंदणी करा",
      subtitle:
        "तुमच्या संस्थांच्या गरजांनुसार तयार केलेल्या व्यक्तिगत डेमोसह पूर्ण अकॅडमिकची शक्ति अनुभव करा.",
      bookDemo: "डेमो बुक करा",
      fillDetails: "तुमचे तपशील भरा आणि आमची टीम लवकरच तुमच्याशी संपर्क साधेल.",
      yourName: "तुमचे नाव",
      institutionName: "संस्थांचे नाव",
      phoneNumber: "फोन नंबर",
      emailAddress: "ईमेल पता",
      institutionAddress: "संस्थांचा पता",
      scheduleDemo: "मुक्त डेमो शेड्यूल करा",
      submitting: "जमा केले जात आहे...",
      thankYou:
        "धन्यवाद! आम्ही लवकरच आपल्याशी आपल्या डेमोची वेळापत्रक करण्यासाठी संपर्क साधु.",
      officeAddress: "कार्यालय पता",
      officeDesc:
        "टेकनोआरव सॉल्यूशन्स. शांती सदन अपार्टमेंट, लिमये नेत्र सेवा हॉस्पिटलच्या जवळ, विश्रामबाग, सांगली, भारत.",
      puneAddr: "गणेश पार्क, लोहेगाव वाघोळी रोड, लोहेगाव, पुणे",  
      phoneNum: "फोन नंबर",
      phoneNumVal: "+91 9130093700",
      emailAddr: "ईमेल पता",
      emailVal: "technoaarv@gmail.com",
      businessHours: "कार्यालयीन वेळ",
      businessDesc: "सोमवार - शनिवार: सकाळी 9:30 - संध्या 6:30",
    },

    // Footer
    footer: {
      company: "कंपनी",
      about: "आमच्याबद्दल",
      careers: "करिअर",
      blog: "ब्लॉग",
      press: "प्रेस",
      product: "उत्पादन",
      features: "वैशिष्ट्य",
      pricing: "मूल्य निर्धारण",
      security: "सुरक्षा",
      roadmap: "रोडमॅप",
      support: "समर्थन",
      contactUs: "आमच्याशी संपर्क करा",
      documentation: "दस्तऐवज",
      helpCenter: "मदत केंद्र",
      status: "स्थिती",
      legal: "कायदेशीर",
      privacy: "गोपनीयता धोरण",
      terms: "सेवेच्या शर्ती",
      copyright: "© 2024 पूर्ण अकॅडमिक. सर्व अधिकार राखीव.",
    },

    // Modules Section Extended
    modulesSection: {
      title: "सर्व प्रकारचे मॉड्यूल्स",
      subtitle:
        "स्कूल व्यवस्थापन सॉफ्टवेअरच्या गरजा पूर्ण करण्यासाठी डिजाइन केलेले आमचे एकीकृत मॉड्यूल्स नक्की जाणून घ्या.",
      // subtitle: "शाळा मॅनेजमेंटच्या सर्व गरजा पूर्ण करण्यासाठी खास बनवलेले आमचे एकत्रित मॉड्यूल्स पहा.",
      admissionTitle: "प्रवेश व्यवस्थापन",
      admissionFeatures: [
        "प्रवेशासाठी येणाऱ्या चौकशी आणि माहितीचे व्यवस्थापन",
        "ऑनलाइन आणि ऑफलाइन ॲडमिशन प्रक्रिया",
        "कागदपत्रांची पडताळणी आणि फायनल नोंदणी",
        "मेरिट लिस्ट (गुणवत्ता यादी) तयार करण्याची सोय",
        "ॲडमिशन कॅन्सलेशन (प्रवेश रद्द करणे) हाताळणे",
        "विद्यार्थ्यांच्या सर्व महत्त्वाच्या नोंदींचे व्यवस्थापन",
      ],
      academicsTitle: "शैक्षणिक व्यवस्थापन",
      academicsFeatures: [
        " वर्ग आणि तुकडीचे (Division) वाटप",
        "प्रत्येक वर्गासाठी विषयांचे नियोजन",
        "वेळापत्रक (Timetable) तयार करणे आणि मॅनेजमेंट",
        "लेसन प्लॅनिंग आणि ट्रॅकिंग",
        "सिलॅबस किती पूर्ण झाला याचा रिपोर्ट",
        "शिक्षकांच्या कामाचे (Workload) नियोजन",
      ],
      examsTitle: "परीक्षा व्यवस्थापन",
      examsFeatures: [
        "परीक्षेचे वेळापत्रक (Timetable) तयार करणे",
        "परीक्षेसाठी वर्गांचे किंवा ब्लॉकचे वाटप",
        "मार्क्स भरणे आणि ग्रेडिंग सिस्टीम",
        "निकालपत्रक किंवा प्रोग्रेस रिपोर्ट तयार करणे",
        "मार्कशीट आणि तात्पुरते प्रमाणपत्र (Provisional Certificate)",
        "विद्यार्थी किंवा वर्गानुसार निकालाचे विश्लेषण",
      ],
      financeTitle: "आर्थिक व्यवस्थापन आणि अकाउंटिंग",
      financeFeatures: [
        "सत्र/अभ्यासक्रमानुसार फीचे दर ठरवणे",
        "ऑनलाइन आणि काउंटरवर (Cash Counter) फी भरणे",
        "कॅश वाउचर नोंद आणि अकाउंट मॅनेजमेंट",
        "बँक समन्वय (Bank Reconciliation)",
        "बॅलन्स शीट (Balance Sheet) आणि बिलिंग",
        "बजेट प्लॅनिंग आणि आर्थिक अहवाल (Reports)",
      ],
      hrTitle: "HR आणि वेतन",
      hrFeatures: [
        "स्टाफची (कर्मचाऱ्यांची) संपूर्ण माहिती एकाच ठिकाणी",
        "फेस (Face), फिंगरप्रिंट आणि RFID हजेरीची सोय",
        "सुट्ट्यांचे व्यवस्थापन (Leave Management System)",
        "पगार पत्रक (Salary Slip) आणि पेरोल तयार करणे",
        "लोन (कर्ज) आणि PF (भविष्य निर्वाह निधी) व्यवस्थापन",
        "इन्कम टॅक्स (Income Tax) हिशोब आणि मॅनेजमेंट",
      ],
      libraryTitle: "ग्रंथालय व्यवस्थापन",
      libraryFeatures: [
        "बारकोड लगावलेली पुस्तके आणि वृत्तपत्र नोंद",
        "पुस्तक घेणे/परत देणे ट्रॅकिंग",
        "विद्यार्थी ग्रंथालय कार्ड तयार करणे",
        "विलंब शुल्क व्यवस्थापन",
        "पुस्तकांना बारकोड बनवणे",
        "मजुदात अहवाल",
      ],
      inventoryTitle: "स्टोर आणि इन्व्हेंटरी",
      inventoryFeatures: [
        "वस्तू आणि सप्लायर्सची (Suppliers) यादी",
        "खरेदीसाठी विनंती आणि मंजुरीची (Approval) सोय",
        "परचेस ऑर्डर (Purchase Order) मॅनेजमेंट",
        "खरेदी-विक्रीच्या व्यवहारांची नोंद",
        "देखभाल आणि दुरुस्तीच्या खर्चाचा हिशोब",
        "शिल्लक मालाचे (Stock) सविस्तर रिपोर्ट",
      ],
      communicationTitle: "संदेश व पत्रव्यवहार",
      communicationFeatures: [
        "एसएमएस (SMS) आणि ईमेलद्वारे महत्त्वाच्या सूचना",
        "पालकांना मुलांच्या हजेरीचे नोटिफिकेशन्स",
        "फी भरण्याची आठवण करून देणारे मेसेज (Fee Reminders)",
        "परीक्षेच्या वेळापत्रकाची (Timetable) माहिती",
        "वाढदिवसाच्या शुभेच्छांचे ऑटोमॅटिक मेसेज",
        "शालेय कार्यक्रम आणि सुट्ट्यांच्या सूचना",
      ],
      mobileTitle: "मोबाइल अ‍ॅप",
      mobileFeatures: [
        "पालक आणि शिक्षकांसाठी लॉगिनची सोय",
        "विद्यार्थ्यांची शैक्षणिक माहिती पाहण्याची सोय",
        "दैनंदिन हजेरीची (Attendance) माहिती",
        "परीक्षेचे वेळापत्रक (Timetable) पाहण्याची सोय",
        "फीची माहिती आणि प्रोग्रेस रिपोर्ट",
        "शिक्षकांशी थेट संवाद साधण्याची सुविधा",
      ],
      budgetTitle: "बजेट व्यवस्थापन",
      budgetFeatures: [
        "उत्पन्न आणि खर्चाचा (Income-Expense) हिशोब ठेवणे",
        "शाळा किंवा मॅनेजमेंटचे बजेट रिपोर्ट तयार करणे",
        "प्रत्येक संस्थेनुसार वेगळे बजेट रिपोर्ट मिळवणे",
        "सर्व शाखांचे एकत्रित (Consolidated) बजेट रिपोर्ट",
        "चालू वर्ष आणि पुढील वर्षाच्या बजेटमधील फरकाची तुलना करणे",
      ],
      donationTitle: "देणगी आणि पावती व्यवस्थापन",
      donationFeatures: [
        "देणगीदारांची (Donors) यादी तयार करणे",
        "सर्व देणग्यांचा हिशोब एकाच ठिकाणी ठेवणे",
        "प्रत्येक शाळेनुसार देणगीचे सविस्तर रिपोर्ट्स मिळवणे",
        "सर्व देणगी पावत्यांचा एकत्रित (Consolidated) रिपोर्ट",
        "80G टॅक्स सवलतीचे रिपोर्ट्स तयार करण्याची सोय",
      ],
      certificatesTitle: "प्रमाणपत्र व्यवस्थापन",
      certificatesFeatures: [
        "फोटोसह किंवा फोटोशिवाय बोनाफाईड सर्टिफिकेट (Bonafide Certificate)",
        "मराठी किंवा इंग्रजी भाषेत शाळा सोडल्याचा दाखला (LC/TC)",
        "चारित्र्य किंवा वर्तणूक प्रमाणपत्र (Character Certificate)",
        "हजेरी प्रमाणपत्र (Attendance Certificate)",
      ],
      idcardTitle: "ID कार्ड व्यवस्थापन",
      idcardFeatures: [
        "आयडी कार्ड प्रिंट करण्याची सोपी सुविधा",
        "विद्यार्थ्यांचे फोटो अपलोड करून झटपट आयडी कार्ड तयार करणे",
      ],
      mealTitle: "दुपारच्या जेवणाचं व्यवस्थापन",
      mealFeatures: [
        "धान्य आणि इतर खाद्यपदार्थांची नवीन यादी तयार करणे व त्यात बदल करणे",
        "धान्य आणि इतर वस्तूंच्या आवकचे (Stock In) रजिस्टर",
        "विद्यार्थी, वर्ग आणि वयानुसार धान्य व वस्तूंचे वाटप",
        "उपस्थित विद्यार्थ्यांच्या संख्येनुसार दररोज शिजवलेल्या धान्याची नोंद",
        "सरकारला लागणारे मासिक, त्रैमासिक आणि वार्षिक सर्व रिपोर्ट्स",
      ],
      scholarshipTitle: "शिष्यवृत्ती व्यवस्थापन",
      scholarshipFeatures: [
        "शिष्यवृत्तीचे प्रकार आणि पेमेंट विभागाची यादी",
        "शिष्यवृत्तीचा सुरुवातीचा बॅलन्स (Opening Balance) आणि वाटप",
        "शिष्यवृत्ती वाटपाचे रिपोर्ट्स आणि वर्षाचा सारांश (Summary)",
        "अतिरिक्त शिष्यवृत्तीचे व्यवस्थापन",
        "जादा झालेली शिष्यवृत्ती परत करण्याची सोय",
        "शिष्यवृत्तीचा हिशोब अकाउंट्स मॉड्यूलशी जोडणे",
      ],
    },

    // Benefits Section Extended
    benefitsSection: {
      benefitForManagement: "स्कूल व्यवस्थापनासाठी",
      benefitForTeachers: "शिक्षकांसाठी",
      benefitForParents: "पालकांसाठी",
      managementBenefits: [
        "झटपट माहितीसाठी रिअल-टाइम डॅशबोर्ड",
        "एकाच ठिकाणाहून अनेक शाखांचे (Branches) व्यवस्थापन",
        "बजेट आणि आर्थिक व्यवहारांचे अचूक रिपोर्ट्स",
        "सर्व सरकारी रिपोर्ट्स एकाच ठिकाणी",
        "कर्मचारी व्यवस्थापन प्रणाली",
        "पालक आणि शिक्षकांमधील संपर्क अधिक सोपा",
      ],
      teacherBenefits: [
        "हजेरी आणि मार्क्स भरण्याची सोपी पद्धत",
        "लेसन प्लॅनिंग आणि सिलॅबस ट्रॅकिंग",
        "वेळ वाचवणारे ऑटोमॅटिक फीचर्स",
        "विद्यार्थ्यांची माहिती एका क्लिकवर",
        "शाळा अंतर्गत मेसेजिंगची सुविधा",
        "वेळापत्रक (Timetable) पाहण्याची सोय",
      ],
      parentBenefits: [
        "मुलांच्या प्रगतीची 'रिअल-टाइम' माहिती",
        "हजेरी आणि परीक्षेचे नोटिफिकेशन्स",
        "फीचा हिशोब आणि ऑनलाइन पेमेंटची सोय",
        "एसएमएस (SMS) आणि अ‍ॅपद्वारे सर्व माहिती",
        "शिक्षकांशी थेट संवाद किंवा चॅटिंग",
        "मोबाईल अ‍ॅपद्वारे वापरण्यास अत्यंत सोपे",
      ],
      benefitsTitle: "सर्वांसाठी लाभ",
      benefitsSubtitle:
        "आमचे स्कूल व्यवस्थापन सॉफ्टवेअर सर्व संबंधितांना मूल्य प्रदान करते - व्यवस्थापन, शिक्षक आणि पालक.",
    },

    // FAQ Section Extended
    faqSection: {
      title: "वारंवार विचारलेले प्रश्न",
      subtitle:
        "आमच्या स्कूल ERP आणि शैक्षणिक व्यवस्थापन सॉफ्टवेअरबद्दल सामान्य प्रश्नांची उत्तरे मिळवा.",
      q1: "स्कूल ERP सॉफ्टवेअर म्हणजे काय?",
      a1: "स्कूल ERP हे शाळा चालवण्यासाठी बनवलेले एक संपूर्ण डिजिटल सॉफ्टवेअर आहे. ॲडमिशन, फी, हजेरी, परीक्षा, शिक्षण, पगार आणि संपर्क यांसारख्या सर्व गोष्टी यात एकाच ठिकाणी उपलब्ध आहेत. 'पूर्ण अकॅडमिक' हे विशेषतः भारतीय शाळांच्या गरजा ओळखून तयार करण्यात आले आहे",
      q2: "शैक्षणिक व्यवस्थापन सॉफ्टवेअर शाळांना कसे मदत करते?",
      a2: "पूर्ण अकॅडमिक'मुळे शाळेची दैनंदिन कामे ऑटोमॅटिक होतात, ज्यामुळे कागदी काम कमी होऊन सर्वांमधील संपर्क सुधारतो. यामध्ये अचूक रिपोर्ट्स त्वरित मिळतात आणि शाळेच्या प्रत्येक कामावर तुम्ही रिअल-टाइम लक्ष ठेवू शकता. यामुळे वेळेची मोठी बचत होते आणि महत्त्वाचे निर्णय घेणे सोपे जाते.",
      q3: "पूर्ण अकॅडमिक CBSE, राज्य बोर्ड आणि कॉलेजांसाठी उपयुक्त आहे का?",
      a3: "हो, 'पूर्ण अकॅडमिक' हे प्राथमिक शाळेपासून ते डिग्री कॉलेजपर्यंतच्या सर्व संस्थांसाठी खास बनवले आहे. हे CBSE, ICSE, राज्य बोर्ड आणि विद्यापीठांच्या सर्व पद्धतींना सपोर्ट करते. तुमच्या शाळेच्या किंवा परीक्षेच्या पद्धतीनुसार हे सॉफ्टवेअर सहज बदलले जाऊ शकते",
      q4: "प्रणाली UDISE, Saral आणि Shala Siddhi सारख्या सरकारी अहवालांना समर्थन देते का?",
      a4: "हो नक्कीच! 'पूर्ण अकॅडमिक' मध्ये UDISE Plus, सरल, शाळा सिद्धी आणि जिल्हा परिषदेचे सर्व महत्त्वाचे सरकारी रिपोर्ट्स तयार करण्याची सोय आहे. हे रिपोर्ट्स फक्त काही क्लिक्समध्ये तयार होतात, ज्यामुळे तुमचा खूप वेळ वाचतो",
      q5: "पूर्ण अकॅडमिक क्लाउड-आधारित शाळा ERP आहे का?",
      a5: "हो, 'पूर्ण अकॅडमिक' हे क्लाउड-आधारित सॉफ्टवेअर आहे. त्यामुळे तुम्ही शाळेचा डेटा कधीही आणि कोठूनही पाहू शकता. तुमचा सर्व डेटा क्लाउडवर सुरक्षितपणे सेव्ह केला जातो, ज्यामुळे तो पूर्णपणे सुरक्षित राहतो आणि तुम्ही तो मोबाईल किंवा कॉम्प्युटरवर सहज वापरू शकता.",
      q6: "पूर्ण अकॅडमिक कोणत्या भाषांमध्ये उपलब्ध आहे?",
      a6: "पूर्ण अकॅडमिक' मराठी आणि इंग्रजी दोन्ही भाषांमध्ये उपलब्ध आहे, ज्यामुळे महाराष्ट्र आणि इतर भागांतील शाळांना ते वापरणे खूप सोपे जाते. सॉफ्टवेअरचे सर्व भाग (मॉड्यूल्स), प्रमाणपत्रे आणि स्क्रीन या दोन्ही भाषांमध्ये वापरता येतात.",
      q7: "विद्यार्थी किंवा शिक्षकांच्या संख्येवर काही मर्यादा आहे का?",
      a7: "नाही, 'पूर्ण अकॅडमिक'मध्ये विद्यार्थी किंवा शिक्षकांच्या संख्येवर कोणतीही मर्यादा नाही. तुमची १०० विद्यार्थ्यांची लहान शाळा असो किंवा हजारो विद्यार्थ्यांच्या अनेक संस्था असलेला मोठा ट्रस्ट, आमचे सॉफ्टवेअर तुमच्या सर्व गरजा सहज पूर्ण करते.",
      q8: "कोणते प्रशिक्षण आणि समर्थन दिले जाते?",
      a8: "अंमलबजावणीच्या वेळी आम्ही सर्व कर्मचाऱ्यांना सविस्तर प्रशिक्षण देतो. आमच्या सपोर्ट टीमकडून तुम्हाला कोणत्याही प्रश्नासाठी मदत मिळेल. सॉफ्टवेअरमध्ये वेळोवेळी होणारे अपडेट्स तुमच्या शाळेला नेहमीच नवीन तंत्रज्ञान मिळवून देतील.",
    },

    // Why Choose Section Extended
    whyChooseSection: {
      subtitle: "भारतीय शाळांसाठी संपूर्ण शैक्षणिक व्यवस्थापन सॉफ्टवेअर",
      description:
        "शाळा चालवण्याच्या प्रभावी पद्धतीमुळे, भारतभरातील ५००+ संस्था 'पूर्ण अकॅडमिक'वर विश्वास ठेवतात. पहिलीपासून डिग्रीपर्यंत, आमचे सॉफ्टवेअर तुमच्या संस्थेच्या खास गरजांनुसार काम करते. तुमची संस्था कोणतीही असो, आमचे सॉफ्टवेअर तुमच्या गरजेनुसार बदलता येते.",
      getStarted: "आज सुरुवात करा",
      benefits: [
"प्रशासकीय कामांसाठी एक संपूर्ण स्कूल ERP सॉफ्टवेअर",
"क्लाउड-आधारित आणि सुरक्षित सिस्टीम, डेटा बॅकअपच्या सुविधेसह",
"मराठी आणि इंग्रजी दोन्ही भाषांचा सपोर्ट, वापरण्यास अत्यंत सोपे",
"UDISE, सरल आणि शाळा सिद्धी यांसारखे सरकारी रिपोर्ट्स तयार करण्याची सोय",
"विद्यार्थी किंवा शिक्षकांच्या संख्येवर कोणतेही बंधन नाही - तुमच्या गरजेनुसार विस्तार करा",
"प्रत्येक प्लॅनसोबत सविस्तर ट्रेनिंग आणि सपोर्टची खात्री",
"शैक्षणिक ट्रस्टांसाठी एकाच ठिकाणाहून अनेक शाखांचे मॅनेजमेंट",
"फी, पगार (Payroll) आणि स्टॉकचा हिशोब एकाच ठिकाणी ठेवणारी सिस्टीम"
],
      preToPostGrad: "प्राथमिक ते पदव्युत्तर",
      cloudBased: "क्लाउड आधारित",
      multiLanguage: "बहु-भाषा",
      govCompliant: "सरकार अनुगत",
    },

    // Testimonials Section Extended
    testimonialsSection: {
      title: "आमचे वापरकर्ते काय म्हणतात",
      subtitle: "शैक्षणिक व्यवस्थापनसाठी भारतभरच्या शिक्षकांद्वारे विश्वास्त.",
      testimonial1:
        "पूर्ण अकॅडमिकने आमच्या शाळा व्यवस्थापनाचे पद्धत बदलले. स्वयंचलित शुल्क संग्रहण आणि पालकांना उपस्थिती SMS ने आमचे प्रशासकीय भार 70% कमी केले आहे.",
      testimonial1Name: "डॉ. सुरेश पाटील",
      testimonial1Role: "प्रधानाध्यापक, आधुनिक सार्वजनिक शाळा",
      testimonial2:
        "सरकार-तयार अहवाल वैशिष्ट्य जीवन रक्षक आहे. UDISE, Saral आणि Shala Siddhi अहवाल एका क्लिकमध्ये तयार होतात. सर्व शाळांसाठी अत्यंत शिफारस केलेले!",
      testimonial2Name: "श्रीमती अंजली देशपांडे",
      testimonial2Role: "प्रशासक, विद्या मंदिर ट्रस्ट",
      testimonial3:
        "पालक म्हणून, मला मोबाइल अ‍ॅप खूप आवडतो. मी कधीही माझ्या मुलाची उपस्थिती, परीक्षा परिणाम आणि शुल्क स्थिती ट्रॅक करू शकतो. शिक्षकांसह संचार खूप सोपे झाले आहे.",
      testimonial3Name: "श्री राजेश कुमार",
      testimonial3Role: "पालक",
      testimonial4:
        "मराठी भाषा समर्थन सर्व कर्मचारीसाठी सुलभ करते. प्रशिक्षण उत्कृष्ट होते आणि समर्थन टीम नेहमी प्रतिक्रियाशील आहे. आमी वापरले असलेले सर्वोत्तम शाळा ERP!",
      testimonial4Name: "प्रो. महादेव कुलकर्णी",
      testimonial4Role: "उप प्रधानाध्यापक, सरस्वती विद्यालय",
    },

    // Customers Section
    customersSection: {
      title: "आमचे विश्वस्त ग्राहक",
      subtitle:
        "शैक्षणिक व्यवस्थापन समाधानसाठी भारतभरच्या शाळा, कॉलेज आणि शैक्षणिक संस्थांद्वारा विश्वास्त.",
      previousCustomers: "मागील ग्राहक",
      nextCustomers: "पुढील ग्राहक",
    },

    // Footer Section Extended
    footerSection: {
      brandDesc:
        "पूर्ण अकॅडमिक भारतीय शैक्षणिक संस्थांसाठी एक संपूर्ण स्कूल ERP आणि शैक्षणिक व्यवस्थापन सॉफ्टवेअर आहे. प्राथमिक ते पदव्युत्तर, आम्ही शाळांना प्रवेश, उपस्थिती, शुल्क, परीक्षा, वेतन आणि संचार स्वयंचलित करण्यास मदत करतो सरकार-अनुगत अहवालसह.",
      quickLinks: "त्वरित लिंक",
      ourModules: "आमचे मॉड्यूल",
      contactUs: "आमच्याशी संपर्क करा",
      home: "होम",
      features: "वैशिष्ट्य",
      modules: "मॉड्यूल",
      benefits: "लाभ",
      faq: "सामान्य प्रश्न",
      contact: "संपर्क",
      admissionManagement: "प्रवेश व्यवस्थापन",
      feeManagement: "शुल्क व्यवस्थापन",
      attendanceSystem: "उपस्थिती प्रणाली",
      examinationModule: "परीक्षा मॉड्यूल",
      hrPayroll: "HR आणि वेतन",
      mobileApp: "मोबाइल अ‍ॅप",
      address1:
        "टेकनोआरव सॉल्यूशन्स. शांती सदन अपार्टमेंट, लिमये नेत्र सेवा हॉस्पिटलच्या जवळ, विश्रामबाग, सांगली, भारत.",
      address2: "गणेश पार्क, लोहेगाव वाघोली रोड, लोहेगाव, पुणे",
      phone: "+91 9130093700",
      email: "technoaarv@gmail.com",
      copyright:
        "© 2024 पूर्ण अकॅडमिक. सर्व अधिकार राखीव. | विकसित आणि TechnoAarv सॉल्यूशन्स द्वारा व्यवस्थापित",
    },

    // Messages
    messages: {
      allFieldsRequired:
        "सर्व फील्ड भरणे आवश्यक आहे. कृपया संपूर्ण माहिती भरा.",
      submissionError: "फॉर्म सबमिट करता आला नाही. कृपया थोड्या वेळाने पुन्हा प्रयत्न करा.",
      unexpectedError: "काहीतरी चुकलं आहे. कृपया पुन्हा प्रयत्न करा.",
      phoneError: "मोबाईल नंबर नेमका १० अंकांचा असावा.",
      emailError: "कृपया योग्य ईमेल पत्ता टाका.",
    },
  },
};

export const getTranslation = (language, path) => {
  const keys = path.split(".");
  let value = translations[language];

  for (let key of keys) {
    if (value && typeof value === "object" && key in value) {
      value = value[key];
    } else {
      return path; // Fallback to the path if translation not found
    }
  }

  return value;
};
